import React from 'react'
import logo from '../images/header-canfax.png'

export default class Home extends React.Component {
  render() {
    return (
      <div className="container d-flex" style={{textAlign: 'center'}}>
        <img
          src={logo}
          alt="CanFax Logo"
          style={{paddingTop: '10px', paddingBottom: '10px'}}
        />
        <p className="inner-content">
          CFXPro is for those looking to have access to breakeven calculators,
          price projections, as well as standard market information for Canadian
          cattle producers. To use, just enter basic information into the
          application to receive calculations that aid in the decision making
          process of buying and selling cattle.
        </p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/home.js